import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as _ from "lodash";
import * as angular from "angular";
import { EntityConfigService } from "../services/entity-config-service";
import { BulkUploadService } from "../services/bulk-upload-service";
import { NotifyService } from "../services/notify-service";
import { StorageService } from "../services/storage-service";
import { EntityService } from "../services/entity-service";
import { CurrencyConversionService } from "../services/currency-conversion-service";
import { AclService } from "../services/acl-service";
import { map } from "d3";


export interface IRLBulkImportUpdateScope extends ng.IScope {
    mode: number;
}

export function RLBulkImportV2() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/bulk-import-v2.html"),
        controllerAs: "biv2VM",
        controller: BulkImportV2Controller,
        scope: {
            mode: "="
        },
        bindToController: true,
        link: (scope: IRLBulkImportUpdateScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: BulkImportV2Controller) => { }
    }
    return directive;
}

export class BulkImportV2Controller {
    static $inject = ["$scope", "$location", "$window", "$q", "$log", "$sce", "entityConfigService", "bulkUploadService", "notifyService", "storage", "entityService", "currencyConversionService", "aclService"];

    mode: number;
    initialized: boolean
    selectedCharTypeID: number;
    selectedTemplateID: number;
    charTypes: Models.ICharacteristicType[];
    parentCharTypes: Models.ICharacteristicType[];
    assocCharTypes: Models.ICharacteristicType[];
    templates: Models.ICharacteristicTemplate[];
    pickedFile: IFilestackPickFile;
    selectedFileName: string;
    selectedAssociationCharTypeID: number;
    allowDownloadTemplate: boolean;
    selectedDateFormat: string;
    bulkUpdateMode: boolean;
    moduleLevelCharTypeIDSelected: boolean;
    preValidationErrorMessage: { [key: number]: string };
    hasPreValidationError: boolean;
    selectedTemplateIDs: number[] = [];
    selectedTemplates: Models.ICharacteristicTemplate[];
    removeSelectedTemplateID: number;
    selectedAssocCharTypes: Models.ICharacteristicType[];
    removeSelectedAssociationCharTypeID: number;
    //allowNestedCharTypeSelection: boolean;
    allowToUpload: boolean;
    selectedParentCharTypeID: number;
    nonModuleCharTypeIDs: { [id: string]: number };
    notAllowBulkUploadCharTypeIDs: { [id: string]: number };
    allowedNestedCharTypeIDs: { [id: string]: number };
    showAssociatedCharTypeIds: boolean;
    contactParties: Models.IParty[];
    selectedContactParties: Models.IParty[];
    showContactParties: boolean;
    selectedPartyID: number;
    removeSelectedPartyID: number;
    showJobProgressStatus: boolean;
    progressStatus: string;
    resultMessage: string;
    jobId: string;
    jobTitle: string;
    selectedParentCharTypes: Models.ICharacteristicType[];
    removeSelectedParentCharTypeID: number;


    //Mapping
    allTemplateChars: Models.ICharacteristicMetaData[];
    isFileHeaderValidated: boolean;
    allFileRows: { [key: number]: Models.IBulkUploadFileHeaderMapping[] } = {};
    headerMappingRow: Models.IBulkUploadFileHeaderMapping[] = [];
    validHeaderMapping: boolean;
    mappingName: string;
    allTemplateCharMetadatas: { [key: string]: Models.ICharacteristicMetaData[] } = {};
    savedMappings: Models.IBulkUploadSavedMapping[] = [];
    selectedMapping: Models.IBulkUploadSavedMapping;
    showMapping: boolean;
    disabled = false;
    btnTitle = "";

    constructor(private $scope: ng.IScope,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private $sce: ng.ISCEService,
        private entityConfigService: EntityConfigService,
        private bulkUploadService: BulkUploadService,
        private notifyService: NotifyService,
        private storage: StorageService,
        private entityService: EntityService,
        private currencyConversionService: CurrencyConversionService,
        private aclService: AclService) {

        this.selectedCharTypeID = null;
        this.selectedTemplateID = null;
        this.charTypes = [];
        this.parentCharTypes = [];
        this.assocCharTypes = [];
        this.templates = [];
        this.selectedAssociationCharTypeID = null;
        this.selectedDateFormat = "mm/dd/yyyy";
        this.bulkUpdateMode = false;
        this.Init();
        this.moduleLevelCharTypeIDSelected = false;
        this.preValidationErrorMessage = {};
        this.hasPreValidationError = false;
        this.selectedTemplates = [];
        this.allowToUpload = false;
        this.selectedParentCharTypeID = null;
        this.nonModuleCharTypeIDs = <{ [id: string]: number }>Consts.AllowMultipleParentCharTypes.IDs;
        this.notAllowBulkUploadCharTypeIDs = <{ [id: string]: number }>Consts.NotBulkUploadCharTypes.IDs;
        this.allowedNestedCharTypeIDs = <{ [id: string]: number }>Consts.AllowedNestedCharTypes.IDs;
        this.showAssociatedCharTypeIds = false;
        this.contactParties = [];
        this.selectedContactParties = [];
        this.showContactParties = false;
        this.showJobProgressStatus = false;
        this.progressStatus = "";
        this.resultMessage = "";
        this.jobId = "";
        this.jobTitle = "";
        this.selectedParentCharTypes = [];
        this.allTemplateChars = [];
        this.isFileHeaderValidated = false;
        this.validHeaderMapping = false;
        this.mappingName = "";
        this.showMapping = false;
        
        $scope.$watch(() => this.mode, (newValue) => {
            if (newValue != undefined) {
                this.btnTitle = newValue == 1 ? "Import" : "Update";
            }            
        });

        $scope.$watch(() => this.selectedCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.CharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedTemplateID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (s) => {
                    if (!_.any(this.selectedTemplates, t => t.templateID == s)) {
                        var selectedTemplate = this.templates.find(t => t.templateID == s);
                        this.selectedTemplates.push(selectedTemplate);
                        _.remove(this.templates, t => t.templateID == s);
                    }
                });
                if (this.selectedCharTypeID > 0 && this.selectedTemplates.length > 0) {
                    this.TemplateSelected();
                }
            }
        }, true);

        $scope.$watch(() => this.removeSelectedTemplateID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (s) => {
                    if (!_.any(this.templates, t => t.templateID == s)) {
                        var selectedTemplate = this.selectedTemplates.find(t => t.templateID == s);
                        this.templates.push(selectedTemplate);
                        _.remove(this.selectedTemplates, t => t.templateID == s);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.selectedParentCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue > 0 && this.selectedCharTypeID != Consts.CharTypeIDs.amount) {
                    this.ParentCharTypeChanged();
                }
            }
        });

        $scope.$watch(() => this.selectedParentCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue && this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                _.forEach(newValue, (ctID) => {
                    if (!_.any(this.selectedParentCharTypes, c => c.charTypeID == ctID)) {
                        var selectedCharType = this.parentCharTypes.find(c => c.charTypeID == ctID);
                        this.selectedParentCharTypes.push(selectedCharType);
                        _.remove(this.parentCharTypes, c => c.charTypeID == ctID);
                    }
                });
                if (this.selectedCharTypeID > 0 && this.selectedParentCharTypes.length > 0) {
                    this.allowDownloadTemplate = true;
                    this.allowToUpload = true;
                    this.showAssociatedCharTypeIds = false;
                }
            }
        }, true);

        $scope.$watch(() => this.removeSelectedParentCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue && this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                _.forEach(newValue, (ctID) => {
                    if (!_.any(this.parentCharTypes, c => c.charTypeID == ctID)) {
                        var selectedCharType = this.selectedParentCharTypes.find(c => c.charTypeID == ctID);
                        this.parentCharTypes.push(selectedCharType);
                        _.remove(this.selectedParentCharTypes, c => c.charTypeID == ctID);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.selectedAssociationCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (s) => {
                    if (!_.any(this.selectedAssocCharTypes, t => t.charTypeID == s)) {
                        var selectedAssocCharType = this.assocCharTypes.find(t => t.charTypeID == s);
                        if (selectedAssocCharType.charTypeID == Consts.CharTypeIDs.user) {
                            this.LoadContactPartiesForTemplates();
                        }
                        this.selectedAssocCharTypes.push(selectedAssocCharType);
                        _.remove(this.assocCharTypes, t => t.charTypeID == s);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.removeSelectedAssociationCharTypeID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (s) => {
                    if (!_.any(this.assocCharTypes, t => t.charTypeID == s)) {
                        var selectedAssocCharType = this.selectedAssocCharTypes.find(t => t.charTypeID == s);
                        this.assocCharTypes.push(selectedAssocCharType);
                        if (selectedAssocCharType.charTypeID == Consts.CharTypeIDs.user) {
                            this.contactParties = [];
                            this.showContactParties = false;
                        }
                        _.remove(this.selectedAssocCharTypes, t => t.charTypeID == s);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.selectedPartyID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (p) => {
                    if (!_.any(this.selectedContactParties, t => t.partyID == p)) {
                        var selectedParty = this.contactParties.find(t => t.partyID == p);
                        this.selectedContactParties.push(selectedParty);
                        _.remove(this.contactParties, t => t.partyID == p);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.removeSelectedPartyID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                _.forEach(newValue, (p) => {
                    if (!_.any(this.contactParties, t => t.partyID == p)) {
                        var selectedParty = this.selectedContactParties.find(t => t.partyID == p);
                        this.contactParties.push(selectedParty);
                        _.remove(this.selectedContactParties, t => t.partyID == p);
                    }
                });
            }
        }, true);

        $scope.$watch(() => this.pickedFile, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.selectedFileName = newValue[0].key;
                this.isFileHeaderValidated = false;
                this.ValidateFileHeaders();
            }
        }, true);

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && (newValue == "Done" || "Failed")) {
                if (newValue == "Failed") {
                    this.notifyService.notifyError(this.resultMessage);
                    this.ResetAll();
                }
                else if (newValue == "Done") {
                    this.showJobProgressStatus = false;
                    this.ResetAll();
                }
            }
        });
    }

    Init() {
        this.notifyService.startProgress();
        this.entityConfigService.getCharacteristicTypes()
            .then((result) => {
                if (this.mode == 2) {
                    this.notAllowBulkUploadCharTypeIDs[Consts.CharTypeIDs.mock.toString()] = Consts.CharTypeIDs.mock;
                }

                this.charTypes = [];
                _.forEach(result, (ct) => {
                    if (!_.any(this.notAllowBulkUploadCharTypeIDs, (id) => id == ct.charTypeID)) {
                        this.charTypes.push(ct);
                    }
                });
                this.notifyService.endProgress();
            });
    }

    CharTypeChanged() {
        if (this.selectedCharTypeID > 0) {
            this.selectedTemplateID = null;
            this.selectedTemplates = [];
            this.removeSelectedTemplateID = null;
            this.removeSelectedAssociationCharTypeID = null;
            this.selectedAssocCharTypes = [];
            this.parentCharTypes = [];
            this.assocCharTypes = [];
            this.allowToUpload = false;
            this.showAssociatedCharTypeIds = false;
            this.contactParties = [];
            this.showContactParties = false;
            this.selectedContactParties = [];
            this.selectedParentCharTypes = [];
            this.isFileHeaderValidated = false;

            this.notifyService.startProgress();
            var promises = [];
            promises.push(this.entityConfigService.getCharacteristicTemplates(this.selectedCharTypeID)
                .then((result) => {
                    if (this.mode == 1) {
                        this.templates = _.filter(result, t => Utils.AclUtil.hasCreateAccess(this.aclService.acls, t.acl));
                    } else {
                        this.templates = _.filter(result, t => Utils.AclUtil.hasWriteAccess(this.aclService.acls, t.acl));
                    }
                }));

            if (this.selectedCharTypeID == Consts.CharTypeIDs.user) {
                var contactCharType = _.find(this.charTypes, (ct) => ct.charTypeID == this.selectedCharTypeID);
                this.parentCharTypes.push(contactCharType);
            }
            else {
                promises.push(this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(this.selectedCharTypeID)
                    .then((results) => {
                        _.forEach(results, (result) => {
                            var assocCharTypeID = result.charTypeID;
                            if (!_.any(this.parentCharTypes, (pct) => pct.charTypeID == assocCharTypeID)) {
                                var parentCharType = _.find(this.charTypes, (ct) => ct.charTypeID == assocCharTypeID);
                                if (parentCharType) {
                                    this.parentCharTypes.push(parentCharType);
                                }
                            }
                        });
                    }));
            }

            this.$q.all(promises)
                .then(() => {
                    if (this.selectedCharTypeID == Consts.CharTypeIDs.usage) {
                        _.remove(this.parentCharTypes, pc => pc.charTypeID == Consts.CharTypeIDs.right);
                    }

                    if (this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                        var amountParentCharTypes: Models.ICharacteristicType[] = [];
                        var usageCharType = _.find(this.parentCharTypes, pc => pc.charTypeID == Consts.CharTypeIDs.usage);
                        if (!_.isEmpty(usageCharType)) {
                            amountParentCharTypes.push(usageCharType);
                        }

                        var invoiceCharType = _.find(this.parentCharTypes, pc => pc.charTypeID == Consts.CharTypeIDs.invoice);
                        if (!_.isEmpty(invoiceCharType)) {
                            amountParentCharTypes.push(invoiceCharType);
                        }
                        this.parentCharTypes = amountParentCharTypes;
                    }
                    this.notifyService.endProgress();
                });
        }
    }

    TemplateSelected() {
        this.isFileHeaderValidated = false;
        if (this.mode == 2) {
            this.allowDownloadTemplate = true;
            this.allowToUpload = true;
            this.showAssociatedCharTypeIds = false;
        }
        else {
            if (_.any(this.nonModuleCharTypeIDs, (id) => id == this.selectedCharTypeID) || this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                this.allowDownloadTemplate = false;
                this.allowToUpload = false;
                this.showAssociatedCharTypeIds = false;
            } else if (this.selectedCharTypeID == Consts.CharTypeIDs.user) {
                this.allowDownloadTemplate = true;
                this.allowToUpload = true;
                this.showAssociatedCharTypeIds = false;
            } else {
                this.allowDownloadTemplate = true;
                this.allowToUpload = true;
                this.showAssociatedCharTypeIds = true;
                if (this.assocCharTypes.length == 0) {
                    this.LoadAssociatedCharTypes();
                }
            }
        }
    }

    ParentCharTypeChanged() {
        this.assocCharTypes = [];
        this.selectedAssocCharTypes = [];
        this.removeSelectedAssociationCharTypeID = null;
        this.selectedAssociationCharTypeID = null;
        this.allowDownloadTemplate = true;
        this.allowToUpload = true;

        if (this.selectedCharTypeID == Consts.CharTypeIDs.user) {
            this.showAssociatedCharTypeIds = false;
        } else if (this.assocCharTypes.length == 0) {
            this.showAssociatedCharTypeIds = true;
            this.LoadAssociatedCharTypes();
        }
        this.isFileHeaderValidated = false;
    }

    LoadAssociatedCharTypes() {
        this.notifyService.startProgress();
        this.entityConfigService.getRelatedConfigurationCharacteristicTypes(this.selectedCharTypeID)
            .then((result) => {
                _.forEach(result, (r) => {
                    switch (r.charTypeID) {
                        case Consts.CharTypeIDs.usage:
                        case Consts.CharTypeIDs.right:
                        case Consts.CharTypeIDs.amount:
                        case Consts.CharTypeIDs.royalty:
                        case Consts.CharTypeIDs.document:
                            break;
                        default:
                            if (_.any(this.charTypes, c => c.charTypeID == r.charTypeID)) {
                                if (this.assocCharTypes.length == 0) {
                                    var ct = _.find(this.charTypes, c => c.charTypeID == r.charTypeID);
                                    this.assocCharTypes.push(ct);
                                }
                                else {
                                    if (!_.any(this.assocCharTypes, ac => ac.charTypeID == r.charTypeID)) {
                                        var ct = _.find(this.charTypes, c => c.charTypeID == r.charTypeID);
                                        this.assocCharTypes.push(ct);
                                    }
                                }
                            }
                    }
                });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    LoadContactPartiesForTemplates() {
        if (this.selectedCharTypeID != Consts.CharTypeIDs.right && this.selectedCharTypeID != Consts.CharTypeIDs.usage) {
            var promises = [];

            if (this.selectedCharTypeID == Consts.CharTypeIDs.usage || this.selectedCharTypeID == Consts.CharTypeIDs.right) {
                this.entityConfigService.getCharacteristicTemplates(this.selectedParentCharTypeID)
                    .then((result) => {
                        _.forEach(result, (template) => {
                            promises.push(this.GetTemplateParties(this.selectedParentCharTypeID, template.templateID));
                        });
                    });
            }
            else {
                _.forEach(this.selectedTemplates, (template) => {
                    promises.push(this.GetTemplateParties(this.selectedCharTypeID, template.templateID));
                });
            }

            this.$q.all(promises)
                .then(() => {
                    this.showContactParties = true;
                });
        }
        else {
            this.showContactParties = false;
        }
    }

    GetTemplateParties(charTypeID: number, templateID: number) {
        return this.entityConfigService.getTemplateParties(charTypeID, templateID)
            .then((result) => {
                _.forEach(result, (templateParty) => {
                    if (!_.any(this.contactParties, cp => cp.partyID == templateParty.partyID)) {
                        this.contactParties.push(templateParty);
                    }
                });
            });
    }

    DownLoadCSVTemplate() {
        var url = "";
        if (this.allowDownloadTemplate) {
            url = "/api/bulkupload/downloadbulkimportv2csvtemplate?";
            url = url + 'mode=' + this.mode;
            url = url + '&charTypeID=' + this.selectedCharTypeID;
            if (this.selectedTemplates == null) {
                url = url + '&templateIDs=';
            }
            else {
                var selectedTemplateIDs = this.selectedTemplates.map(s => s.templateID).join(",");
                url = url + '&templateIDs=' + selectedTemplateIDs;
            }

            if (this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                if (this.selectedParentCharTypes.length > 0) {
                    var selectedParentCharTypeIDs = this.selectedParentCharTypes.map(s => s.charTypeID).join(",");
                    url = url + '&selectedParentCharTypeIDs=' + selectedParentCharTypeIDs;
                }
                else {
                    url = url + '&selectedParentCharTypeIDs=';
                }
            }
            else {
                if (this.selectedParentCharTypeID == null) {
                    url = url + '&selectedParentCharTypeIDs=';
                }
                else {
                    url = url + '&selectedParentCharTypeIDs=' + this.selectedParentCharTypeID;
                }
            }

            if (this.selectedAssocCharTypes == null) {
                url = url + '&selectedAssocCharTypeIDs=';
            }
            else {
                var selectedAssocCharTypeIDs = this.selectedAssocCharTypes.map(s => s.charTypeID).join(",");
                url = url + '&selectedAssocCharTypeIDs=' + selectedAssocCharTypeIDs;
            }

            if (this.selectedContactParties.length == 0) {
                url = url + '&selectedPartyIDs=';
            }
            else {
                var selectedPartyIDs = this.selectedContactParties.map(s => s.partyID).join(",");
                url = url + '&selectedPartyIDs=' + selectedPartyIDs;
            }
        }
        return url;
    }

    ValidateFileHeaders() {
        var tmdPromises = [];
        var allTemplateChars: Models.ICharacteristicMetaData[] = [];
        this.allTemplateCharMetadatas = {};
        this.selectedMapping = undefined;

        _.forEach(this.selectedTemplates, (template) => {
            tmdPromises.push(this.entityConfigService.getCharacteristicTemplate(this.selectedCharTypeID, template.templateID)
                .then((result) => {
                    this.allTemplateCharMetadatas[template.templateID] = result.characteristicMetaDatas;
                }));
        });

        var getFileHeaderPromise = this.bulkUploadService.getFileHeaders(this.selectedFileName)
            .then((result) => {
                this.allFileRows = result.data;
                this.headerMappingRow = _.cloneDeep(this.allFileRows[0]);
            });

        this.$q.all([tmdPromises, getFileHeaderPromise, this.GetSavedMappings()])
            .then(() => {
                _.each(this.allTemplateCharMetadatas, function (templateCharMetadatas: Models.ICharacteristicMetaData[], key) {
                    if (key != undefined) {
                        if (allTemplateChars.length == 0) {
                            allTemplateChars = templateCharMetadatas;
                        }
                        else {
                            var newTemplateCharMetaDatas = templateCharMetadatas.filter(function (cmd) {
                                return !allTemplateChars.some(function (all) {
                                    return cmd.label == all.label;
                                });
                            });

                            allTemplateChars = _.union(allTemplateChars, newTemplateCharMetaDatas);
                        }
                    }
                });
            })
            .finally(() => {
                if (this.mode == 1) {
                    var templateMappers: Models.ICharacteristicMetaData[] = [];
                    templateMappers.push(this.getFakeCharMetaData("Template ID", -1));
                    templateMappers.push(this.getFakeCharMetaData("Template Label", -1));

                    var parentMappers: Models.ICharacteristicMetaData[] = [];

                    if (this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                        if (this.selectedParentCharTypes.length > 0) {
                            _.forEach(this.selectedParentCharTypes, (s) => {
                                parentMappers.push(this.getFakeCharMetaData("Parent " + s.charTypeName + " ID", -2));
                            });
                        }
                    }
                    else {
                        var selectedParentCharType = _.find(this.parentCharTypes, p => p.charTypeID == this.selectedParentCharTypeID);
                        if (selectedParentCharType != undefined) {
                            parentMappers.push(this.getFakeCharMetaData("Parent " + selectedParentCharType.charTypeName + " ID", -2));
                        }
                    }

                    var associatedMappers: Models.ICharacteristicMetaData[] = [];

                    _.forEach(this.selectedAssocCharTypes, (s) => {
                        if (s.charTypeID != Consts.CharTypeIDs.user) {
                            associatedMappers.push(this.getFakeCharMetaData("Associated " + s.charTypeName + " ID", -3));
                        }
                        else if (this.selectedCharTypeID == Consts.CharTypeIDs.right || this.selectedCharTypeID == Consts.CharTypeIDs.usage) {
                            associatedMappers.push(this.getFakeCharMetaData("Associated " + s.charTypeName + " ID", -3));
                        }
                    });

                    var partyMappers: Models.ICharacteristicMetaData[] = [];

                    _.forEach(this.selectedContactParties, (sp) => {
                        associatedMappers.push(this.getFakeCharMetaData("Associated " + sp.partyName + " ID", -3));
                    });


                    allTemplateChars = _.union(allTemplateChars, templateMappers);

                    if (parentMappers.length > 0) {
                        allTemplateChars = _.union(allTemplateChars, parentMappers);
                    }

                    if (associatedMappers.length > 0) {
                        allTemplateChars = _.union(allTemplateChars, associatedMappers);
                    }

                    if (partyMappers.length > 0) {
                        allTemplateChars = _.union(allTemplateChars, partyMappers);
                    }

                    var recTitleTemplateChar = _.find(allTemplateChars, a => a.tagLabel == "entity_title");
                    this.allTemplateChars = _.filter(allTemplateChars, a => a.systemIndicator != -1);
                    if (recTitleTemplateChar != undefined) {
                        this.allTemplateChars.push(recTitleTemplateChar);
                    }
                }
                else {
                    var recIDTemplateChar = _.find(allTemplateChars, a => a.tagLabel == "entity_id");
                    var recTitleTemplateChar = _.find(allTemplateChars, a => a.tagLabel == "entity_title");
                    this.allTemplateChars = _.filter(allTemplateChars, a => a.systemIndicator != -1);

                    if (recIDTemplateChar != undefined) {
                        recIDTemplateChar.label = _.find(this.charTypes, c => c.charTypeID == this.selectedCharTypeID).charTypeName.trim() + " ID";
                        this.allTemplateChars.push(recIDTemplateChar);
                    }
                    if (recTitleTemplateChar != undefined) {
                        this.allTemplateChars.push(recTitleTemplateChar);
                    }
                }

                _.forEach(this.allTemplateChars, (char) => {
                    char.label = char.label.trim();
                });

                _.forEach(this.headerMappingRow, (headerRow) => {
                    if (_.any(this.allTemplateChars, a => a.label == headerRow.fileColumnHeader)) {
                        headerRow.isMapped = true;
                        headerRow.characteristicLabel = headerRow.fileColumnHeader;
                        headerRow.characteristicID = this.allTemplateChars.find(a => a.label == headerRow.fileColumnHeader).characteristicID;
                    }
                    else {
                        headerRow.isMapped = false;
                    }
                });

                this.isFileHeaderValidated = true;
                this.showMapping = true;
                this.AreHeadersMapped();
            });
    }

    private getFakeCharMetaData(label: string, charID: number = 0): Models.ICharacteristicMetaData {
        var fakeCharMedata: Models.ICharacteristicMetaData = {
            charTypeID: 0,
            characteristicID: charID,
            label: label,
            tagLabel: "",
            maxLength: 100,
            dataTypeID: 0,
            systemIndicator: 0,
            multipleIndicator: 0,
            charValueSetID: "",
            reportIndicator: 1,
            description: "",
            groupID: 1,
            requiredIndicator: 1,
            sequenceNumber: 0,
            charValueSourceID: "",
            acl: "",
            triggerTypeID: "",
            triggerValue: ""
        };
        return fakeCharMedata;
    }

    Import() {
        if (this.validHeaderMapping) {
            this.notifyService.startProgress();

            var selectedTemplateIDs: number[] = [];
            if (this.selectedTemplates.length > 0) {
                selectedTemplateIDs = this.selectedTemplates.map(c => c.templateID);
            }

            var selectedParentCharTypeIDs: number[] = [];
            if (this.selectedCharTypeID == Consts.CharTypeIDs.amount) {
                if (this.selectedParentCharTypes.length > 0) {
                    selectedParentCharTypeIDs = this.selectedParentCharTypes.map(c => c.charTypeID);
                }
            }
            else {
                if (this.selectedParentCharTypeID != null) {
                    selectedParentCharTypeIDs.push(this.selectedParentCharTypeID);
                }
            }

            var selectedAssocCharTypeHeaders: string[] = [];
            if (this.selectedAssocCharTypes.length > 0) {
                selectedAssocCharTypeHeaders = this.selectedAssocCharTypes.map(c => c.charTypeName);
            }

            var selectedPartyNames: string[] = [];
            if (this.selectedContactParties.length > 0) {
                selectedPartyNames = this.selectedContactParties.map(c => c.partyName);
            }

            if (this.mode == 2) {
                selectedParentCharTypeIDs = [];
                selectedAssocCharTypeHeaders = [];
                selectedPartyNames = [];
            }

            var mappedHeaders = this.allFileRows[0];

            this.bulkUploadService.DoBulkImportV2(this.mode, this.selectedCharTypeID, selectedTemplateIDs, selectedParentCharTypeIDs, this.selectedFileName, this.selectedDateFormat, selectedAssocCharTypeHeaders, selectedPartyNames, mappedHeaders)
                .then((result) => {
                    var jobNotificationMessage = "";
                    if (this.mode == 1) {
                        jobNotificationMessage = "Your records are now importing. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can perform another import or leave this page and continue working elsewhere.";
                    }
                    else {
                        jobNotificationMessage = "Your records are now updating. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can perform another update or leave this page and continue working elsewhere.";
                    }
                    alert(jobNotificationMessage);
                    this.showJobProgressStatus = true;
                    this.jobId = result.jobID;
                    this.jobTitle = result.jobTitle;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        else {
            alert("Not all file headers are mapped or valid");
        }
    }

    ResetAll() {
        this.selectedCharTypeID = null;
        this.selectedTemplateID = null;
        this.charTypes = [];
        this.parentCharTypes = [];
        this.assocCharTypes = [];
        this.templates = [];
        this.selectedAssociationCharTypeID = null;
        this.selectedDateFormat = "mm/dd/yyyy";
        this.bulkUpdateMode = false;
        this.moduleLevelCharTypeIDSelected = false;
        this.preValidationErrorMessage = {};
        this.hasPreValidationError = false;
        this.selectedTemplates = [];
        this.allowToUpload = false;
        this.selectedParentCharTypeID = null;
        this.showAssociatedCharTypeIds = false;
        this.contactParties = [];
        this.selectedContactParties = [];
        this.showContactParties = false;
        this.showJobProgressStatus = false;
        this.selectedParentCharTypes = [];

        this.allTemplateChars = [];
        this.isFileHeaderValidated = false;
        this.validHeaderMapping = false;
        this.mappingName = "";
        this.showMapping = false;
        this.allFileRows = { };
        this.headerMappingRow = [];
        this.allTemplateCharMetadatas = { };
        this.savedMappings = [];
        this.selectedMapping = undefined;
        this.disabled = false;
        this.Init();
    }

    CheckMapping(headerRow: Models.IBulkUploadFileHeaderMapping, index: number) {
        var mappedHeaders = _.filter(this.headerMappingRow, (cmd) => cmd.fileColumnHeader == headerRow.fileColumnHeader);
        if (mappedHeaders.length > 1) {
            headerRow.isMapped = false;
            headerRow.fileColumnHeader = "";
            alert("That field name is already mapped to another column. You can remove the mapping from the other column, then try again. Otherwise, select another field name.");
        }
        else {
            var headerRowCharMetaData = _.find(this.allTemplateChars, a => a.label == headerRow.fileColumnHeader);
            headerRow.characteristicLabel = headerRowCharMetaData.label;

            if (headerRowCharMetaData.characteristicID > 0) {
                if (this.IsCharInAllTemplate(headerRowCharMetaData.characteristicID, headerRowCharMetaData.label)) {
                    headerRow.characteristicID = 0;
                }
                else {
                    headerRow.characteristicID = headerRowCharMetaData.characteristicID;
                }
            }
            else {
                headerRow.characteristicID = headerRowCharMetaData.characteristicID;
            }

            this.allFileRows[0][index].characteristicID = headerRowCharMetaData.characteristicID;
            this.allFileRows[0][index].characteristicLabel = headerRowCharMetaData.label;
            headerRow.isMapped = true;
        }
        this.AreHeadersMapped();
    }

    AreHeadersMapped() {
        if (_.any(this.headerMappingRow, (hdr) => hdr.isMapped == false)) {
            this.validHeaderMapping = false;
        }
        else {
            this.validHeaderMapping = true;
        }
    }

    SaveHeaderMapping() {

        if (_.any(this.savedMappings, m => m.mappingName.trim().toLowerCase() == this.mappingName.trim().toLowerCase())) {
            alert("There is already column mapping exists with the name" + this.mappingName +". Can you please select a different name?");
        }
        else {
            this.notifyService.startProgress();
            var headerMappingRow = _.cloneDeep(this.headerMappingRow);

            _.forEach(headerMappingRow, (mappedRow) => {
                if (mappedRow.characteristicID > 0) {
                    _.each(this.allTemplateCharMetadatas, function (templateCharMetadatas: Models.ICharacteristicMetaData[], key) {
                        if (key != undefined) {
                            var mappedRowCharMetaData = _.find(templateCharMetadatas, tmd => tmd.characteristicID == mappedRow.characteristicID && tmd.label == mappedRow.characteristicLabel);
                            if (mappedRowCharMetaData != undefined) {
                                mappedRow.templateID = _.parseInt(key);
                            }
                        }
                    });
                }
                else if (mappedRow.characteristicID == 0) {
                    mappedRow.characteristicID = this.allFileRows[0].find(a => a.characteristicLabel == mappedRow.characteristicLabel).characteristicID;
                }

                if (_.any(this.allFileRows[0].find(a => a.characteristicLabel == mappedRow.characteristicLabel))) {
                    mappedRow.fileColumnHeader = this.allFileRows[0].find(a => a.characteristicLabel == mappedRow.characteristicLabel).fileColumnHeader;
                }
            });

            var saveHeaderMapping: Models.ISavedBulkUploadV2HeaderMapping = {
                mappingName: this.mappingName,
                charTypeID: this.selectedCharTypeID,
                mappedHeaders: headerMappingRow,
                templateIDs: this.selectedTemplates.map(s => s.templateID),
                isGlobal: 1,
                mode: this.mode
            };

            this.bulkUploadService.saveBulkUploadMapping(saveHeaderMapping)
                .then((result) => {
                    if (result.success && result.data) {
                        this.notifyService.notifySuccess("Saved Selected Mapping");
                    }
                    else {
                        this.notifyService.notifyError("Error Saving Selected Mapping");
                    }
                }).finally(() => {
                    this.GetSavedMappings()
                        .then(() => {
                            var selectedMapping = _.find(this.savedMappings, map => map.mappingName == this.mappingName);
                            this.selectedMapping = selectedMapping;
                            this.mappingName = "";
                            this.notifyService.endProgress();
                        });
                });
        }
    }

    GetSavedMappings(): ng.IPromise<any> {
        this.notifyService.startProgress();
        var getMappings: Models.ISavedBulkUploadV2HeaderMapping = {
            mappingName: "",
            charTypeID: this.selectedCharTypeID,
            mappedHeaders: null,
            templateIDs: this.selectedTemplates.map(s => s.templateID),
            isGlobal: 1,
            mode: this.mode
        };

        return this.bulkUploadService.getSavedMappings(getMappings)
            .then((result) => {
                this.savedMappings = [];
                this.savedMappings = result.data;
                this.notifyService.endProgress();
            });
    }

    IsCharInAllTemplate(characteristicID: number, characteristicLabel: string): boolean {
        var count: number = 0;
        _.each(this.allTemplateCharMetadatas, function (templateCharMetadatas: Models.ICharacteristicMetaData[], key) {
            if (key != undefined) {
                var mappedRowCharMetaData = _.find(templateCharMetadatas, tmd => tmd.characteristicID == characteristicID && tmd.label == characteristicLabel);
                if (mappedRowCharMetaData != undefined) {
                    count++;
                }
            }
        });

        return this.selectedTemplates.map(s => s.templateID).length == count;
    }

    SelectMapping(mapping: Models.IBulkUploadSavedMapping): ng.IPromise<any> {
        this.notifyService.startProgress();

        this.selectedMapping = mapping;
        var getMappingDetails: Models.ISavedBulkUploadV2HeaderMapping = {
            mappingName: mapping.mappingName,
            charTypeID: this.selectedCharTypeID,
            mappedHeaders: null,
            templateIDs: this.selectedTemplates.map(s => s.templateID),
            isGlobal: 1,
            mode: this.mode
        };

        return this.bulkUploadService.getMappingDetails(getMappingDetails)
            .then((result) => {
                var mappedHeaders: Models.IBulkUploadFileHeaderMapping[] = [];
                mappedHeaders = result.data;

                _.forEach(mappedHeaders, (mh) => {
                    var headerRow = _.find(this.headerMappingRow, hr => hr.fileColumnHeader == mh.fileColumnHeader);

                    if (headerRow != undefined) {
                        var index = this.headerMappingRow.indexOf(headerRow);

                        if (headerRow.isMapped) {
                            if (mh.characteristicID !== headerRow.characteristicID) {
                                var templateChar = this.allTemplateChars.find(chr => chr.characteristicID === mh.characteristicID);
                                if (templateChar !== undefined) {
                                    headerRow.fileColumnHeader = templateChar.label;
                                }
                            }
                            this.allFileRows[0][index].characteristicID = mh.characteristicID;
                            this.allFileRows[0][index].characteristicLabel = mh.characteristicLabel;
                        }
                        else {
                            var headerRowCharMetaData: Models.ICharacteristicMetaData;
                            if (mh.characteristicID > 0) {
                                headerRowCharMetaData = _.find(this.allTemplateCharMetadatas[mh.templateID], a => a.characteristicID == mh.characteristicID);
                            }
                            else {
                                headerRowCharMetaData = _.find(this.allTemplateChars, a => a.label == mh.characteristicLabel);
                            }

                            headerRow.characteristicLabel = headerRowCharMetaData.label;
                            headerRow.fileColumnHeader = headerRowCharMetaData.label;

                            if (headerRowCharMetaData.characteristicID > 0) {
                                if (this.selectedTemplateIDs.length > 1 && this.IsCharInAllTemplate(headerRowCharMetaData.characteristicID, headerRowCharMetaData.label)) {
                                    headerRow.characteristicID = 0;
                                    headerRow.templateID = 0;
                                }
                                else {
                                    headerRow.characteristicID = headerRowCharMetaData.characteristicID;
                                    headerRow.templateID = mh.templateID;
                                }
                            }
                            else {
                                headerRow.characteristicID = headerRowCharMetaData.characteristicID;
                            }

                            this.allFileRows[0][index].characteristicID = headerRow.characteristicID;
                            this.allFileRows[0][index].characteristicLabel = headerRowCharMetaData.label;
                            if (headerRow.templateID > 0) {
                                this.allFileRows[0][index].templateID = mh.templateID;
                            }
                            headerRow.isMapped = true;
                        }
                       
                    }
                });

            }).finally(() => {
                this.AreHeadersMapped();
                this.notifyService.endProgress();
            });
    }

    deleteMapping(mapping: Models.IBulkUploadSavedMapping) {
        this.notifyService.startProgress();
        var deleteMapping: Models.ISavedBulkUploadV2HeaderMapping = {
            mappingName: mapping.mappingName,
            charTypeID: this.selectedCharTypeID,
            mappedHeaders: null,
            templateIDs: this.selectedTemplates.map(s => s.templateID),
            isGlobal: 1,
            mode: this.mode
        };

        this.bulkUploadService.deleteMapping(deleteMapping)
            .then((result) => {
                if (result.success && result.data) {
                    _.remove(this.savedMappings, sv => sv.mappingName == mapping.mappingName);
                    this.notifyService.notifySuccess("Deleted Selected Mapping");
                }
                else {
                    this.notifyService.notifyError("Error Deleting Selected Mapping");
                }
                this.notifyService.endProgress();
            });
    }
}
